export const FETCH_SEUIL_PASSAGE_REQUEST = 'FETCH_SEUIL_PASSAGE_REQUEST';
export const FETCH_SEUIL_PASSAGE_SUCCESS = 'FETCH_SEUIL_PASSAGE_SUCCESS';
export const FETCH_SEUIL_PASSAGE_FAILURE = 'FETCH_SEUIL_PASSAGE_FAILURE';

export const CREATE_SEUIL_PASSAGE_REQUEST = 'CREATE_SEUIL_PASSAGE_REQUEST';
export const CREATE_SEUIL_PASSAGE_SUCCESS = 'CREATE_SEUIL_PASSAGE_SUCCESS';
export const CREATE_SEUIL_PASSAGE_FAILURE = 'CREATE_SEUIL_PASSAGE_FAILURE';

export const UPDATE_SEUIL_PASSAGE_REQUEST = 'UPDATE_SEUIL_PASSAGE_REQUEST';
export const UPDATE_SEUIL_PASSAGE_SUCCESS = 'UPDATE_SEUIL_PASSAGE_SUCCESS';
export const UPDATE_SEUIL_PASSAGE_FAILURE = 'UPDATE_SEUIL_PASSAGE_FAILURE';

export const DELETE_SEUIL_PASSAGE_REQUEST = 'DELETE_SEUIL_PASSAGE_REQUEST';
export const DELETE_SEUIL_PASSAGE_SUCCESS = 'DELETE_SEUIL_PASSAGE_SUCCESS';
export const DELETE_SEUIL_PASSAGE_FAILURE = 'DELETE_SEUIL_PASSAGE_FAILURE';

export const fetchSeuilPassageRequest = (companyId) => ({
    type: FETCH_SEUIL_PASSAGE_REQUEST,
    companyId
});

export const fetchSeuilPassageSuccess = (seuils) => ({
    type: FETCH_SEUIL_PASSAGE_SUCCESS,
    payload: seuils
});

export const fetchSeuilPassageFailure = (error) => ({
    type: FETCH_SEUIL_PASSAGE_FAILURE,
    payload: error
});

export const createSeuilPassageRequest = (seuilData) => ({
    type: CREATE_SEUIL_PASSAGE_REQUEST,
    payload: seuilData
});

export const createSeuilPassageSuccess = (seuil) => ({
    type: CREATE_SEUIL_PASSAGE_SUCCESS,
    payload: seuil
});

export const createSeuilPassageFailure = (error) => ({
    type: CREATE_SEUIL_PASSAGE_FAILURE,
    payload: error
});

export const updateSeuilPassageRequest = (id, seuilData) => ({
    type: UPDATE_SEUIL_PASSAGE_REQUEST,
    payload: { id, seuilData }
});

export const updateSeuilPassageSuccess = (seuil) => ({
    type: UPDATE_SEUIL_PASSAGE_SUCCESS,
    payload: seuil
});

export const updateSeuilPassageFailure = (error) => ({
    type: UPDATE_SEUIL_PASSAGE_FAILURE,
    payload: error
});

export const deleteSeuilPassageRequest = (id) => ({
    type: DELETE_SEUIL_PASSAGE_REQUEST,
    payload: id
});

export const deleteSeuilPassageSuccess = (id) => ({
    type: DELETE_SEUIL_PASSAGE_SUCCESS,
    payload: id
});

export const deleteSeuilPassageFailure = (error) => ({
    type: DELETE_SEUIL_PASSAGE_FAILURE,
    payload: error
});
